import { logger } from './services/loggingService';
// Boot watchdog: if app doesn't mount within 10s, surface a debug banner (CSP-safe)
try {
  (window as any).__CYCLONE_BOOT_WATCHDOG__ = setTimeout(() => {
    if (!(window as any).__CYCLONE_MOUNTED__) {
      logger.error('[Cyclone] App did not mount within 10s. Showing watchdog banner.');
      const banner = document.createElement('div');
      banner.setAttribute('data-cyclone-watchdog', '');
      banner.style.position = 'fixed';
      banner.style.zIndex = '99999';
      banner.style.top = '0';
      banner.style.left = '0';
      banner.style.right = '0';
      banner.style.background = '#111';
      banner.style.color = '#fff';
      banner.style.padding = '8px 12px';
      banner.style.fontFamily = 'system-ui,Segoe UI,Roboto,Helvetica,Arial,sans-serif';
      banner.style.fontSize = '12px';
      banner.style.lineHeight = '1.4';
      banner.textContent = 'Cyclone startup is taking longer than expected. Check Network for failed chunks and Console for errors. (watchdog)';
      try { document.body.appendChild(banner); } catch (err) {
        logger.warn('Watchdog failed to append banner', { error: err instanceof Error ? err.message : String(err) });
      }
    }
  }, 10000);
} catch (err) {
  logger.warn('Watchdog initialization failed', { error: err instanceof Error ? err.message : String(err) });
}


